import store from '@/store'

import { MetierWsTpu } from 'modulewebservice'
import { MetierLocalStorage } from 'modulelocalstorage'

import i18n from '../lang/index.js'

export class Carrier {
  static searchContact (successcallback, errorcallback, name = null, mail = null, phone = null, search = null) {
    store.commit('loader', i18n.t('loader.contact_search'))

    MetierWsTpu.callGetContact(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      null,
      name,
      mail,
      phone,
      search
    )
      .then(
        (response) => {
          if (response.OK === 1) {
            successcallback(response.Contacts)
          } else {
            errorcallback(response.Msg)
          }
        },
        (e) => {
          errorcallback(e.message)
        }
      )
      .finally(() => {
        store.commit('loader', false)
      })
  }

  static setContact (
    successcallback, errorcallback,
    idContact = null, idBadge = null,
    lastname = null, firstname = null, mail = null,
    phone = null, address = null,
    civility = null, sex = null, birthday = null,
    password = null, stopLoader = true
  ) {
    store.commit(
      'loader',
      idContact == null
        ? i18n.t('loader.contact_creation')
        : i18n.t('loader.contact_update')
    )

    MetierWsTpu.callSetContact(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      idContact, idBadge,
      lastname, firstname, mail,
      phone, address,
      civility, sex, birthday,
      password,
      MetierLocalStorage.getSerial()
    )
      .then(
        (response) => {
          if (response.OK === 1) {
            if (stopLoader) store.commit('loader', false)
            successcallback(response)
          } else {
            store.commit('loader', false)
            errorcallback(response.Msg)
          }
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static getContactCards (idCarrier, successcallback, errorcallback, stopLoader = true) {
    store.commit('loader', i18n.t('loader.contact_search_cards'))

    MetierWsTpu.callGetContactCards(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession().session,
      idCarrier,
    )
      .then(
        (response) => {
          if (response.OK === 1) {
            if (stopLoader) store.commit('loader', false)
            successcallback(response.CartesFidelite, response.CartesPme)
          } else {
            errorcallback(response.Msg)
            store.commit('loader', false)
          }
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static addContactCard (idCarrier, cardNumber, successcallback, errorcallback, typeScan = 'NFC', typeCard = 'FID', cardCode = null) {
    store.commit('loader', i18n.t('loader.contact_add_card'))

    MetierWsTpu.callAddContactCard(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession().session,
      idCarrier,
      cardNumber,
      typeScan, // NFC/QR/MAN
      typeCard, // FID/PME
      cardCode // Not null if MAN
    )
      .then(
        (response) => {
          if (response.OK === 1) {
            successcallback(response.Carte)
          } else {
            errorcallback(response.Msg)
          }
        },
        (e) => {
          errorcallback(e.message)
        }
      )
      .finally(() => {
        store.commit('loader', false)
      })
  }

  // *********************************************************
  // *********************************************************

  static sendByMail (subject, lines, carrier, idBadge, successCallback, errorCallback) {
    store.commit('loader', i18n.t('loader.send_ticket'))

    MetierWsTpu.callMail(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      subject,
      lines,
      carrier,
      idBadge
    )
      .then(
        (response) => {
          if (response.OK === 1) {
            successCallback()
          } else {
            errorCallback(response.Msg ? response.Msg : response.Message)
          }
        },
        (e) => {
          errorCallback(e.message)
        }
      )
      .finally(() => {
        store.commit('loader', false)
      })
  }
}
